<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานการแก้ไขรายละเอียดของรายการส่งเสริมการขาย
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> รายงานการแก้ไขรายละเอียดของรายการส่งเสริมการขาย
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="wrapper_history">
                  <h3 v-if="this.history.length > 0">ชื่อรายการส่งเสริมการขาย : {{ this.promotion_name }}</h3>
                  <h3 v-else>ไม่พบประวัติการแก้ไข</h3>
                  <el-collapse >
                    <el-collapse-item v-for="(item,index) in this.history" :key="index">
                      <template slot="title">
                        <div style="width:20%;">
                          <label for>{{ item.editor }}</label>
                        </div>
                        <div align="right" style="width:80%;">
                          <label for>วันที่และเวลา {{ item.created_at }}</label>
                        </div>
                      </template>
                      <el-table :data="item.row" style="width: 100%">
                        <el-table-column prop="colname" class="red" label="หัวข้อที่มีการแก้ไข"></el-table-column>
                        <el-table-column prop="old_data" label="ข้อมูลเดิมก่อนหน้า"></el-table-column>
                        <el-table-column prop="new_data" label="ข้อมูลที่แก้ไขใหม่"></el-table-column>
                      </el-table>
                    </el-collapse-item>
                  </el-collapse>
                  <el-button type="primary" style="margin-top: 20px" @click="goBack()">ย้อนกลับ</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex"
export default {
  data() {
    return {
      label_position: "top",
      tableProps: {
        border: true,
        stripe: true,
        defaultSort: {
          prop: "flow_no",
          order: "descending"
        }
      }
    };
  },
  computed: {
    ...mapState({
      history : store => store.Promotion.histories,
      promotion_name : store=>store.Promotion.historyHeader
    })
  },
  methods: {
    goBack(){
      this.$router.push({name : 'Manage_mobile'})
    }
  }
};
</script>
<style >
.el-table__header tr th .cell{
  color:black;
}
</style>

